import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function useGetWhereLabel() {
  const [label, setLabel] = useState('');
  const { where } = useSelector(state => state.mainFilter.searchEngine);

  useEffect(() => {
    const getLabelValue = (data) => {
      const isDestinationsGroups =
        data.destinationsGroups.filter((item) => item.active).length > 0;
      const isDestinations =
        data.destinations?.filter((item) => item.active).length > 0;

      const label = `${data.destinationsGroups
        .filter((item) => item.active)
        .map((item) => item.name)
        .join(', ')}${
        isDestinationsGroups && isDestinations ? ', ' : ''
      } ${data.destinations
        .filter((item) => item.active)
        .map((item) => item.name)
        .join(', ')}`;

      return isDestinations || isDestinationsGroups
        ? label
        : '';
    };

    setLabel(getLabelValue(where));
  }, [where]);

  return label;
}
